<template>
    <transition name="slide-fade">
        <div class="modal-cookie" :class="{ 'open': open }" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full p-3 px-5 pb-4 relative">
                    <div class="absolute right-6 top-7">
                        <img @click="hide()" class="w-4 h-4" src="../../../assets/icon/dialog/close.svg"/>
                    </div>
                    <div class="text-center text-lg pt-3 text-blue-1" v-html="lbl.consent_cookie.title"></div>
                    <div class="text-left text-sm pt-3 text-gray-secondary" v-html="lbl.consent_cookie.message"></div>
                    <div @click="clickOpenPdpa()" class="text-left text-sm pb-5 text-green-1 underline" v-html="lbl.consent_cookie.privacy"></div>
                    <div class="m-5">
                        <VBtn @click="clickOk()"
                            blocked
                            large
                            variant="primary">
                            {{ lbl.consent_cookie.confirm }}
                        </VBtn>
                    </div>
                </div>
            </div>

            <Footer :hasPoweredBy="false"></Footer>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import VBtn from "@/components/Button/VBtn.vue";
import Footer from "@/components/Layout/Footer/Footer.vue";

export default {
    name: "AlertModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    components: {
        VBtn,
        Footer
    },
    data: function () {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickOpenPdpa: function () {
            this.hide();
            this.controller.sendCallbackOpenPdpa();
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/modal.scss";
.modal-cookie {
    @extend %modal;
    top: unset;
    .modal-content {
        width: 100%;
        border-top-left-radius: 28px;
        border-top-right-radius: 28px;
        .pdpa-content{
            height: calc(90vh - 77px);
            overflow: scroll;
        }
    }
    .label {
        background-image: url("~@/assets/button/bg.svg");
        background-size: 100%;
    }
}
</style>
